import {Dispatchable} from "../../stem-core/src/base/Dispatcher";
import {apiConnection} from "../../client/connection/BlinkApiConnection";
import {iFrameState} from "./IFrameState";
import {iFrameMerchantService} from "./IframeMerchantService";

// TODO: We probably want to generate this list automatically from the API.
//  These are the endpoints that receive a request extending
//  MerchantConversionRequest.
const CONVERSION_METADATA_ENDPOINTS = [
    "/payment_methods/add_token/",
    "/payment_methods/add_payment_method/",
    "/user_addresses/",
    "/donations/donate/",
    "/subscriptions/subscribe/",
    "/external_providers/login_with_cds/",
    "/external_providers/login_with_one_count_user/",
    "/external_providers/subscribe_with_cds/",
    "/external_providers/donate_with_cds/",
    "/users/login/",
    "/users/update_newsletter_subscriptions/",
    "/users/generate_merchant_session/",
    "/users/request_email_login_code/",
    "/users/login_with_email_code/",
    "/users/give_merchant_consent/",
    "/users/request_email_change/",
    "/users/confirm_email_change/",
    "/socialauth/google/",
    "/socialauth/facebook/",
    "/socialauth/linkedin/",
    "/socialauth/github/",
    "/socialauth/twitter/connect/",
    "/socialauth/confirm_social_signup/",
    "/signup/register/",
    "/signup/confirm_email/",
];

class IFrameMetadataModule extends Dispatchable {
    init() {
        apiConnection.ajaxHandler.addPreprocessor((options, input) => {
            let url = (new URL(input instanceof Request ? input.url : input)).pathname;
            if (url[url.length - 1] !== "/") {
                url += "/";
            }
            if (CONVERSION_METADATA_ENDPOINTS.indexOf(url) >= 0) {
                options.data = options.data || {};
                options.data.metadata = {
                    createdFromUrl: iFrameState.merchantPageUrl,
                    referredFromUrl: iFrameState.merchantPageReferrerUrl,
                    ...iFrameState.metadata,
                    ...(options.data.metadata || {}),
                };
                options.data.referralMerchantId = iFrameMerchantService.merchantId;
            }
        });
    }
}

export const iFrameMetadataModule = new IFrameMetadataModule();
